import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import background from "assets/images/homePage/nextGenSection/bg_textbox.png";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            backgroundImage: `url(${background})`,
            backgroundPosition: "center",
            backgroundSize: "100% 100%",
            padding: theme.spacing(3),
            boxSizing: "border-box"
        },
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {}

export default function NextGenTextBox(props: IProps) {
    const classes = useStyles();
    const { children, className, ...rest } = props;

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            {children}
        </div>
    );
}
